export const initialState = {
    status: 'idle',
};
